import { createFeatureSelector } from '@ngrx/store';
import { ImportExportLiteralsReducer, ImportExportLiteralsState } from './import-export-literals.reducer';
import { LocaleLiteralsReducer, LocaleLiteralsState } from './locale-literals.reducer';
import { LiteralsSearchReducer, LiteralsSearchState } from './search-literals.reducer';
import { SideNavReducer, SidenavState } from './sidenav-reducer';

export const featureLocaleName = 'Locale';

export interface DragonflyLocaleState {
  search: LiteralsSearchState;
  sidenav: SidenavState;
  locale: LocaleLiteralsState;
  importExportLiterals: ImportExportLiteralsState;
}

export const moduleLocaleReducers = {
  search: LiteralsSearchReducer,
  sidenav: SideNavReducer,
  locale: LocaleLiteralsReducer,
  importExportLiterals: ImportExportLiteralsReducer,
};

export const getDragonflyLocaleState = createFeatureSelector<DragonflyLocaleState>(featureLocaleName);
